import { gql } from "@apollo/client";

export const get_practitioners = gql`
  query Practitioners(
    $where: PractitionerWhereInput
    $take: Int
    $orderBy: [PractitionerOrderByWithRelationInput!]
  ) {
    practitioners(where: $where, take: $take, orderBy: $orderBy) {
      name
      id
      status
      sex
      role
      image
      sort_order
      created_at
      clinic_id
      username
      is_app_user
      max_booking_count
      _count {
        bookings
        checkins
      }
    }
  }
`;
export const getPractitionersVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  status?: string[] | string;
  searchText?: string | null;
  take: number;
}) => {
  const { status = [], searchText } = data;
  let variables: any = {},
    where: any = {},
    OR: any[] = [];
  if (searchText && searchText !== "") {
    OR.push({ name: { contains: searchText } });
    OR.push({ phonenumber: { contains: searchText } });
  }
  where.clinic_id = { equals: data.clinicId };
  // where.created_at = { gte: data.startDate, lte: data.endDate };
  where.status = {
    notIn: ["CANCEL"],
    ...(status.length > 0 && { in: status }),
  };
  if (OR.length > 0) where.OR = OR;
  variables.where = where;
  variables.orderBy = [{ sort_order: "asc" }, { created_at: "desc" }];
  variables.take = 100;
  return variables;
};

export const get_group_by_checkin_practitioner_count = gql`
  query GroupByCheckInPractitionerCount(
    $clinic_id: String!
    $from_time: DateTime!
    $to_time: DateTime!
    $practitioner_ids: [String!]
    $skip: Int
    $take: Int
  ) {
    groupByCheckInPractitionerCount(
      clinic_id: $clinic_id
      from_time: $from_time
      to_time: $to_time
      practitioner_ids: $practitioner_ids
      skip: $skip
      take: $take
    ) {
      data {
        _count {
          _all
        }
        practitioner_id
        practitioner_name
        practitioner_image
      }
      totalCount
    }
  }
`;

export const getGroupByCheckInPractitionerCountVar = (data: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  practitionerIds?: string[];
  skip?: number;
  take?: number;
}) => ({
  clinic_id: data.clinicId,
  from_time: data.startDate,
  to_time: data.endDate,
  practitioner_ids: data.practitionerIds,
  skip: data.skip ?? 0,
  take: data.take ?? 20,
});

export const get_practitioner_checkin_count = gql`
  query GroupByCheckIn(
    $by: [CheckInScalarFieldEnum!]!
    $where: CheckInWhereInput
  ) {
    groupByCheckIn(by: $by, where: $where) {
      _count {
        _all
      }
      practitioner_id
      clinic_id
      status
    }
  }
`;
export const getPractitionerCheckInCountVar = (data: {
  clinicId: string;
  practitionerIds: string[];
  startDate: Date;
  endDate: Date;
  status?: string | string[];
}) => {
  let variables: any = {};
  variables.by = ["practitioner_id", "clinic_id", "status"];
  variables.where = {
    clinic_id: { equals: data.clinicId },
    in_time: { gte: data.startDate, lte: data.endDate },
    practitioner_id: { in: data.practitionerIds },
    status: { in: data.status },
  };
  return variables;
};
export const get_practitioner_booking_count = gql`
  query _count($by: [BookingScalarFieldEnum!]!, $where: BookingWhereInput) {
    groupByBooking(by: $by, where: $where) {
      _count {
        _all
      }
      practitioner_id
      clinic_id
    }
  }
`;
export const getPractitionerBookingCountVar = (data: {
  clinicId: string;
  practitionerIds: string[];
  startDate: Date;
  endDate: Date;
}) => {
  let variables: any = {};
  variables.by = ["practitioner_id", "clinic_id"];
  variables.where = {
    clinic_id: { equals: data.clinicId },
    from_time: { gte: data.startDate, lte: data.endDate },
    practitioner_id: { in: data.practitionerIds },
  };
  return variables;
};

export const get_practitioner = gql`
  query Practitioner(
    $where: PractitionerWhereUniqueInput!
    $servicesWhere2: ServiceWhereInput
  ) {
    practitioner(where: $where) {
      image
      name
      id
      status
      sex
      role
      phonenumber
      max_booking_count
      _count {
        bookings
        checkins
      }
      leaves {
        from_time
        to_time
        practitioner_id
        status
        remark
      }
      metadata
      services(where: $servicesWhere2) {
        id
        name
        image
        duration
      }
    }
  }
`;

export const getPractitionerVar = (data: {
  PractitionerId: string;
  clinicId: string;
}) => ({
  where: {
    id: data.PractitionerId,
  },
  servicesWhere2: {
    clinic_id: {
      equals: data.clinicId,
    },
    status: {
      equals: "ACTIVE",
    },
    practitioners: {
      some: {
        id: {
          equals: data.PractitionerId,
        },
      },
    },
  },
});

export const update_one_practitioner = gql`
  mutation UpdateOnePractitioner(
    $data: PractitionerUpdateInput!
    $where: PractitionerWhereUniqueInput!
  ) {
    updateOnePractitioner(data: $data, where: $where) {
      id
    }
  }
`;

export const getConnectServiceWitPractitionerVar = (
  practitionerId: string,
  services: Array<{ id: string }>
) => ({
  variables: {
    where: {
      id: practitionerId,
    },
    data: {
      services: {
        connect: services,
      },
    },
  },
});

export const getDisconnectServiceWitPractitionerVar = (
  practitionerId: string,
  serviceId: string
) => ({
  variables: {
    where: {
      id: practitionerId,
    },
    data: {
      services: {
        disconnect: [{ id: serviceId }],
      },
    },
  },
});

export const getUpdateOnePractionerVar = (
  id: string,
  clinicCode: string,
  data: any
) => {
  let variables: any = {},
    update: any = {};
  variables.where = { id };

  const { password: _, ...modData } = data;
  if (data.password == null) {
    data = modData;
  }

  // Handle username specially - only include if it has a value
  if (data.username != null && data.username.trim() !== "") {
    data.username = `${data.username.trim()}@${clinicCode.toLowerCase()}`;
  } else {
    // Remove username from update if it's empty/null
    delete data.username;
  }

  if (typeof data === "object") {
    // Filter out undefined, null, and empty string values
    update = Object.assign(
      {},
      ...Object.keys(data)
        .filter((k) => {
          const value = data[k];
          return value !== undefined && value !== null && value !== "";
        })
        .map((k) => ({ [k]: { set: data[k] } }))
    );
  }
  variables.data = update;
  return variables;
};

export const get_practitioner_list_for_sale_channel = gql`
  query Practitioners(
    $where: PractitionerWhereInput
    $orderBy: [PractitionerOrderByWithRelationInput!]
  ) {
    practitioners(where: $where, orderBy: $orderBy) {
      id
      name
      image
    }
  }
`;

export const getPractitionerListSaleChannelVar = (clinicId: string) => {
  const variable = {
    where: {
      clinic_id: { equals: clinicId },
      status: { equals: "ACTIVE" },
    },
    orderBy: [{ name: "asc" }],
  };
  return variable;
};
